/**
 * Returns Tailwind classes for the activity/income-type badge.
 */
export function getActivityBadgeStyle(type) {
  switch (type) {
    case 'Passive':
      return 'bg-amber-50 text-amber-700 border border-amber-200/50';
    case 'Experience Builder':
      return 'bg-indigo-50 text-indigo-700 border border-indigo-200/50';
    case 'Remote':
      return 'bg-sky-50 text-sky-700 border border-sky-200/50';
    case 'Hybrid':
      return 'bg-violet-50 text-violet-700 border border-violet-200/50';
    case 'Active':
    default:
      return 'bg-emerald-50 text-emerald-700 border border-emerald-200/50';
  }
}

/**
 * Returns Tailwind classes for the safety grade badge.
 */
export function getSafetyBadgeStyle(grade) {
  switch (grade) {
    case 'A':
      return { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200/50', label: 'Safe', dot: 'bg-emerald-500' };
    case 'B':
      return { bg: 'bg-green-50', text: 'text-green-700', border: 'border-green-200/50', label: 'Good', dot: 'bg-green-500' };
    case 'C':
      return { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200/50', label: 'Caution', dot: 'bg-amber-500' };
    case 'D':
      return { bg: 'bg-orange-50', text: 'text-orange-700', border: 'border-orange-200/50', label: 'High Risk', dot: 'bg-orange-500' };
    case 'F':
      return { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200/50', label: 'Avoid', dot: 'bg-red-500' };
    default:
      return { bg: 'bg-slate-50', text: 'text-slate-600', border: 'border-slate-200/50', label: 'Unrated', dot: 'bg-slate-400' };
  }
}

/**
 * Returns Tailwind classes for the skill level / difficulty badge.
 */
export function getSkillBadgeStyle(level) {
  switch (level) {
    case 'Beginner':
      return 'bg-teal-50 text-teal-700';
    case 'Intermediate':
      return 'bg-blue-50 text-blue-700';
    case 'Advanced':
      return 'bg-purple-50 text-purple-700';
    case 'Expert':
      return 'bg-rose-50 text-rose-700';
    default:
      return 'bg-slate-50 text-slate-600';
  }
}
